import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DocumentationDrawerData } from 'src/app/services/drawer.service';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { DRAWER_DATA } from 'src/app/shared/injector-tokens';
import { DrawerLayoutComponent } from '../../drawer-layout/drawer-layout.component';
import { UiIconComponent } from '../../../ui/icon/icon.component';
import { DocumentationComponent } from '../../../shared/documentation/documentation.component';
import { DocumentationService } from '../../../services/documentation.service';
import { UiButtonDirective } from '../../../ui/button/button.directive';

@Component({
    selector: 'documentation-drawer-wrapper',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './documentation-drawer-wrapper.component.html',
    imports: [
        DrawerLayoutComponent,
        UiIconComponent,
        DocumentationComponent,
        UiButtonDirective,
    ],
})
export class DocumentationDrawerWrapperComponent {
  private readonly data = inject<DocumentationDrawerData>(DRAWER_DATA);
  private readonly documentation = inject(DocumentationService);
  readonly contentQuery = injectQuery(() => this.documentation.documentationPageQueryOptions(this.data.slug));
  readonly content = computed(() => this.contentQuery.data() ?? null);
  readonly title = computed(() => this.content()?.title ?? this.titleFromSlug(this.data.slug));
  readonly canonicalUrl = computed(
    () => this.content()?.canonicalUrl ?? `https://budgets.money/${encodeURIComponent(this.data.slug)}/`,
  );

  private titleFromSlug(slug: string): string {
    return slug
      .split(/[-\s]+/)
      .filter(Boolean)
      .map(word => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
      .join(' ');
  }
}
